import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Section from 'components/common/Section';
import paths from 'routes/paths';

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing your donation...');

  useEffect(() => {
    const redirectStatus = searchParams.get('redirect_status');

    if (redirectStatus === 'succeeded') {
      setStatus('success');
      setMessage('Donation completed successfully!');
      toast.success('Donation completed successfully!');
      const id = setTimeout(() => navigate(paths.allDonations), 2000);
      return () => clearTimeout(id);
    }

    if (redirectStatus === 'processing') {
      setStatus('processing');
      setMessage(
        'Your payment is being processed. You will receive confirmation shortly.'
      );
      const id = setTimeout(() => navigate(paths.allDonations), 2500);
      return () => clearTimeout(id);
    }

    setStatus('error');
    setMessage(
      redirectStatus
        ? 'Payment was not successful. Please try again.'
        : 'Missing payment confirmation. Redirecting...'
    );
    const id = setTimeout(() => navigate(paths.addDonation), 2500);
    return () => clearTimeout(id);
  }, [searchParams, navigate]);

  return (
    <Section className="py-0">
      <Card className="min-vh-75">
        <Card.Body className="d-flex flex-column align-items-center justify-content-center py-5">
          {status === 'processing' && (
            <>
              <Spinner
                animation="border"
                variant="primary"
                className="mb-4"
                style={{ width: '4rem', height: '4rem' }}
              />
              <h3>Processing Your Donation</h3>
              <p className="text-muted fs-5">{message}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="text-success mb-4" style={{ fontSize: '6rem' }}>
                &#10003;
              </div>
              <h3 className="text-success">Payment Successful!</h3>
              <p className="text-muted fs-5">{message}</p>
              <p className="text-muted">Redirecting to donations...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="text-danger mb-4" style={{ fontSize: '6rem' }}>
                &#10007;
              </div>
              <h3 className="text-danger">Something Went Wrong</h3>
              <p className="text-muted fs-5">{message}</p>
              <p className="text-muted">Redirecting...</p>
            </>
          )}
        </Card.Body>
      </Card>
    </Section>
  );
}

export default PaymentSuccess;
